export default (theme) => ({
  title: {
    marginBottom: 12,
  },
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupWrapper: {
    width: 240,
    marginLeft: 24,
    marginRight: 24,
  },
  typeWrapper: {
    width: 240,
    marginLeft: 24,
    marginRight: 24,
  },
  statusWrapper: {
    width: 240,
  },
  surveyRespondentWrapper: {
    width: 240,
    marginLeft: 24,
    marginRight: 24,
  },
  surveyTypeWrapper: {
    width: 240,
  },
  contentWrapper: {
    marginTop: 12,
  },
  root: {
    border: `1px solid ${theme.palette.tableBorderColor}`,
    borderRadius: 5,
    borderCollapse: 'unset',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 0,
  },
  paginationRoot: {
    border: `1px solid ${theme.palette.tableBorderColor}`,
    borderRadius: 5,
    borderCollapse: 'unset',
    borderTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    paddingBottom: 1,
  },
  addWrapper: {
    position: 'fixed',
    right: 24,
    bottom: 24,
  },
  roleWrapper: {
    color: theme.palette.primary.main,
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  numberCell: {
    width: 10,
    padding: 12,
  },
  nameCell: {
    width: '25%',
  },
  idCell: {
    width: '10%',
  },
  groupCell: {
    width: '10%',
  },
  surveyTypeCell: {
    width: '20%',
  },
  surveyRespondentCell: {
    width: '10%',
  },
  maxTimeCell: {
    width: '10%',
  },
  questionsCountCell: {
    width: '10%',
  },
  statusCell: {
    width: '11%',
  },
  actionsCell: {},
  selectWrapper: {
    paddingRight: 24,
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 24,
    height: 56,
  },
  resetWrapper: {
    marginLeft: 24,
  },
  searchWrapper: {
    flexGrow: 1,
  },
  iconButtonText: {
    width: 25,
    height: 25,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
